import api from "../api";
import { authHeaders } from "../utils/csrf";


export async function getAccountPolicy(signal) {
  const response = await api.get("/api/auth/policy/", { signal });
  return response.data;
}

export async function createPendingIntent(payload) {
  const response = await api.post("/api/auth/intents/", payload);
  return response.data;
}

export async function getPendingIntent(intentId, signal) {
  const response = await api.get(`/api/auth/intents/${encodeURIComponent(intentId)}/`, { signal });
  return response.data;
}

export async function claimPendingIntent(intentId) {
  const response = await api.post(`/api/auth/intents/${encodeURIComponent(intentId)}/claim/`);
  return response.data;
}

export async function resumePendingIntent(intentId) {
  const response = await api.post(`/api/auth/intents/${encodeURIComponent(intentId)}/resume/`);
  return response.data;
}

export async function getOnboarding(signal) {
  const response = await api.get("/api/auth/onboarding/", { signal });
  return response.data;
}

export async function saveOnboarding(payload) {
  const response = await api.patch("/api/auth/onboarding/", payload);
  return response.data;
}

export async function saveOnboardingStep(step, payload = {}) {
  const response = await api.patch(
    `/api/auth/onboarding/steps/${encodeURIComponent(step)}/`,
    payload
  );
  return response.data;
}

export async function getOnboardingGoals(signal) {
  const response = await api.get("/api/auth/onboarding/goals/", { signal });
  return response.data?.results || [];
}

export async function saveOnboardingGoals(selectedGoals) {
  const response = await api.put("/api/auth/onboarding/goals/", {
    selected_goals: selectedGoals,
  });
  return response.data;
}

export async function saveOnboardingPreferences(payload) {
  const response = await api.patch("/api/auth/onboarding/preferences/", payload);
  return response.data;
}

export async function completeOnboarding() {
  const response = await api.post("/api/auth/onboarding/complete/");
  return response.data;
}

export async function resumeOnboarding() {
  const response = await api.post("/api/auth/onboarding/resume/");
  return response.data;
}

export async function verifyOnboardingEmail(token) {
  const response = await api.post("/api/auth/verify-email/", { token });
  return response.data;
}

export async function resendOnboardingEmail(email) {
  const response = await api.post("/api/auth/verify-email/resend/", { email });
  return response.data;
}

export async function correctOnboardingEmail(email) {
  const response = await api.post("/api/auth/email/", { email });
  return response.data;
}

export async function uploadOnboardingAvatar(file) {
  const body = new FormData();
  body.append("avatar", file);
  const response = await api.post("/api/auth/public-profile/avatar/", body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function confirmAgeEligibility(birthDate) {
  const response = await api.post("/api/auth/age/confirm/", {
    birth_date: birthDate,
  });
  return response.data;
}

export async function acceptAccountRules(payload) {
  const response = await api.post("/api/auth/rules/accept/", payload, {
    headers: authHeaders(),
  });
  return response.data;
}
